var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"materi-page"},[_c('div',{staticClass:"container-fluid mt-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 mb-5 mb-xl-0"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }